import { Pipe } from '@angular/core';
var IsArrayPipe = (function () {
    function IsArrayPipe() {
    }
    IsArrayPipe.prototype.transform = function (input) {
        return Array.isArray(input);
    };
    return IsArrayPipe;
}());
export { IsArrayPipe };
IsArrayPipe.decorators = [
    { type: Pipe, args: [{ name: 'isArray' },] },
];
/** @nocollapse */
IsArrayPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-array.js
// module id = 218
// module chunks = 4